/* ============================================================
   SIERRA WISHLIST — theme-native wishlist (localStorage)
   Дані: [{h: handle, v: variantId|null, vt: variantTitle|null, t: ts}]
   Аналітика: Meta Pixel (AddToWishlist, ShareWishlist, SaveSharedWishlist)
              + GA4 (add_to_wishlist, share, save_shared_wishlist)
   Також тут: синхронізація крапок мобільної свайп-галереї карток
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'sierra_wishlist_v1';
  var PAGE_URL = '/pages/wishlist';

  var T = {
    add: 'Додати до списку бажань',
    remove: 'Вилучити зі списку бажань',
    addToCart: 'Додати в кошик',
    showInCart: 'Показати в кошику',
    chooseSize: 'Обрати розмір',
    soldOut: 'Розпродано',
    soldOutHint: 'Додай в обране — так ти не загубиш модель, коли вона повернеться в наявність.',
    linkCopied: 'Посилання скопійовано',
    igHint: 'Посилання скопійовано — встав у пост чи сторіз Instagram',
    addedToCart: 'Додано в кошик',
    addedToWl: 'Додано до списку бажань',
    emptyList: 'Список бажань порожній',
    savedToMine: 'Список збережено до вашого списку бажань'
  };

  /* ---------- store ---------- */
  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('sierra:wl:change'));
  }
  function has(handle) { return read().some(function (i) { return i.h === handle; }); }
  function addItem(handle, variantId, variantTitle) {
    var list = read();
    if (list.some(function (i) { return i.h === handle; })) return;
    list.push({ h: handle, v: variantId || null, vt: variantTitle || null, t: Date.now() });
    write(list);
  }
  function removeItem(handle) {
    write(read().filter(function (i) { return i.h !== handle; }));
  }
  function toggleItem(handle, variantId, variantTitle) {
    if (has(handle)) { removeItem(handle); return false; }
    addItem(handle, variantId, variantTitle);
    return true;
  }

  /* ---------- аналітика ---------- */
  function trackAddToWishlist(p, variant) {
    try {
      var price = (variant ? variant.price : p.price) / 100;
      if (window.fbq) {
        window.fbq('track', 'AddToWishlist', {
          content_ids: [String(variant ? variant.id : p.id)],
          content_type: 'product',
          content_name: p.title,
          value: price,
          currency: 'UAH'
        });
      }
      if (window.gtag) {
        window.gtag('event', 'add_to_wishlist', {
          currency: 'UAH',
          value: price,
          items: [{
            item_id: String(p.id),
            item_name: p.title,
            item_variant: variant && variant.title !== 'Default Title' ? variant.title : undefined,
            price: price,
            quantity: 1
          }]
        });
      }
    } catch (e) {}
  }
  function trackShare(method, count) {
    try {
      if (window.fbq) window.fbq('trackCustom', 'ShareWishlist', { share_method: method, items_count: count });
      if (window.gtag) window.gtag('event', 'share', { method: method, content_type: 'wishlist', item_count: count });
    } catch (e) {}
  }

  /* ---------- product data cache ---------- */
  var productCache = {};
  function getProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch('/products/' + handle + '.js')
      .then(function (r) { if (!r.ok) throw new Error('404'); return r.json(); })
      .catch(function () { return null; });
    return productCache[handle];
  }

  /* ---------- cart ---------- */
  var cartVariantIds = [];
  function refreshCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartVariantIds = (cart.items || []).map(function (i) { return i.variant_id; });
      })
      .catch(function () {});
  }
  function addToCart(variantId, btn) {
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function () {
        cartVariantIds.push(variantId);
        toast(T.addedToCart);
        var link = document.createElement('a');
        link.className = 'sierra-wl-item__cta';
        link.href = '/cart';
        link.textContent = T.showInCart;
        btn.replaceWith(link);
        try {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } catch (e) {}
      })
      .catch(function () { btn.disabled = false; });
  }

  /* ---------- helpers ---------- */
  function money(cents) {
    return '₴' + new Intl.NumberFormat('uk-UA').format(Math.round(cents / 100));
  }
  function imgUrl(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  var toastTimer;
  function toast(msg) {
    var el = document.getElementById('sierra-wl-toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  /* Надійне копіювання: Clipboard API з fallback на execCommand. */
  function copyText(text) {
    return new Promise(function (resolve) {
      function fallback() {
        try {
          var ta = document.createElement('textarea');
          ta.value = text;
          ta.setAttribute('readonly', '');
          ta.style.position = 'fixed';
          ta.style.top = '0';
          ta.style.left = '0';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.focus();
          ta.select();
          ta.setSelectionRange(0, text.length);
          document.execCommand('copy');
          document.body.removeChild(ta);
        } catch (e) {}
        resolve();
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(resolve, fallback);
      } else {
        fallback();
      }
    });
  }

  function shareUrl(list) {
    var items = (list || read()).map(function (i) { return i.v ? i.h + ':' + i.v : i.h; }).join(',');
    var url = location.origin + PAGE_URL + '?items=' + encodeURIComponent(items);
    /* на неопублікованій темі прокидаємо preview_theme_id, щоб посилання працювало під час тестів */
    var th = window.Shopify && window.Shopify.theme;
    if (th && th.role && th.role !== 'main' && th.id) url += '&preview_theme_id=' + th.id;
    return url;
  }

  /* ---------- sync hearts / counters ---------- */
  function syncUI() {
    var list = read();
    var handles = {};
    list.forEach(function (i) { handles[i.h] = true; });

    document.querySelectorAll('[data-sierra-wl-heart]').forEach(function (btn) {
      var active = !!handles[btn.getAttribute('data-handle')];
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-label', active ? T.remove : T.add);
    });

    var pdpBtn = document.getElementById('sierra-wl-product-btn');
    if (pdpBtn) {
      var active2 = !!handles[pdpBtn.getAttribute('data-handle')];
      pdpBtn.classList.toggle('is-active', active2);
      pdpBtn.querySelector('.sierra-wl-product-btn__label').textContent = active2 ? T.remove : T.add;
    }

    var count = document.getElementById('sierra-wl-count');
    if (count) {
      count.textContent = list.length;
      count.hidden = list.length === 0;
    }
  }
  document.addEventListener('sierra:wl:change', syncUI);

  /* ---------- серце на картках: делегація ---------- */
  document.addEventListener('click', function (e) {
    var heart = e.target.closest('[data-sierra-wl-heart]');
    if (!heart) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = heart.getAttribute('data-handle');
    var added = toggleItem(handle, null, null);
    if (added) {
      toast(T.addedToWl);
      getProduct(handle).then(function (p) { if (p) trackAddToWishlist(p, null); });
    }
  });

  /* ---------- мобільна свайп-галерея карток: синхронізація крапок ----------
     scroll не спливає, тому слухаємо у фазі захоплення (capture) одним обробником */
  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (!track || !track.classList || !track.classList.contains('sierra-swipe__track')) return;
    var idx = Math.round(track.scrollLeft / track.clientWidth);
    var dots = track.parentElement.querySelectorAll('.sierra-swipe__dots span');
    for (var i = 0; i < dots.length; i++) {
      if (i === idx) dots[i].classList.add('is-active');
      else dots[i].classList.remove('is-active');
    }
  }, true);

  /* ---------- кнопка на сторінці товару (інжекція) ---------- */
  function initProductButton() {
    var m = location.pathname.match(/\/products\/([a-z0-9\-]+)/i);
    if (!m) return;
    var handle = m[1];
    var form = document.querySelector('main form[action*="/cart/add"]');
    if (!form || document.getElementById('sierra-wl-product-btn')) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = 'sierra-wl-product-btn';
    btn.className = 'sierra-wl-product-btn';
    btn.setAttribute('data-handle', handle);
    btn.innerHTML =
      '<svg class="sierra-wl-ic-outline" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 21c-.4 0-7.5-4.6-9.3-9.4C1.2 7.6 3.6 4 7 4c2.2 0 3.9 1.2 5 3 1.1-1.8 2.8-3 5-3 3.4 0 5.8 3.6 4.3 7.6C19.5 16.4 12.4 21 12 21z"/></svg>' +
      '<svg class="sierra-wl-ic-filled" viewBox="0 0 24 24" fill="currentColor"><path d="M12 21c-.4 0-7.5-4.6-9.3-9.4C1.2 7.6 3.6 4 7 4c2.2 0 3.9 1.2 5 3 1.1-1.8 2.8-3 5-3 3.4 0 5.8 3.6 4.3 7.6C19.5 16.4 12.4 21 12 21z"/></svg>' +
      '<span class="sierra-wl-product-btn__label">' + T.add + '</span>';

    btn.addEventListener('click', function () {
      if (has(handle)) { removeItem(handle); return; }
      var idInput = form.querySelector('input[name="id"], select[name="id"]');
      var variantId = idInput ? parseInt(idInput.value, 10) : null;
      getProduct(handle).then(function (p) {
        var vt = null, v = null;
        if (p && variantId) {
          v = p.variants.filter(function (x) { return x.id === variantId; })[0] || null;
          if (v && v.title !== 'Default Title') vt = v.title;
        }
        addItem(handle, variantId, vt);
        toast(T.addedToWl);
        if (p) trackAddToWishlist(p, v);
      });
    });

    form.parentNode.insertBefore(btn, form.nextSibling);

    /* розпроданий товар: підказка під кнопкою замість глухого кута */
    getProduct(handle).then(function (p) {
      if (p && !p.available && !document.getElementById('sierra-wl-soldout-hint')) {
        var hint = document.createElement('p');
        hint.id = 'sierra-wl-soldout-hint';
        hint.className = 'sierra-wl-soldout-hint';
        hint.textContent = T.soldOutHint;
        btn.parentNode.insertBefore(hint, btn.nextSibling);
      }
    });

    syncUI();
  }

  /* ---------- drawer ---------- */
  var sortMode = 'recent';
  function openDrawer() {
    var d = document.getElementById('sierra-wl-drawer');
    var o = document.getElementById('sierra-wl-overlay');
    if (!d) return;
    d.hidden = false; o.hidden = false;
    requestAnimationFrame(function () { d.classList.add('is-open'); o.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
    refreshCart().then(renderDrawer);
  }
  function closeDrawer() {
    var d = document.getElementById('sierra-wl-drawer');
    var o = document.getElementById('sierra-wl-overlay');
    if (!d) return;
    d.classList.remove('is-open'); o.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { d.hidden = true; o.hidden = true; }, 300);
  }

  function resolveItems(list) {
    return Promise.all(list.map(function (i) {
      return getProduct(i.h).then(function (p) {
        if (!p) return null;
        var variant = null;
        if (i.v) variant = p.variants.filter(function (x) { return x.id === i.v; })[0] || null;
        if (!variant && p.variants.length === 1) variant = p.variants[0];
        return { item: i, product: p, variant: variant };
      });
    })).then(function (rows) { return rows.filter(Boolean); });
  }

  function sortRows(rows) {
    var r = rows.slice();
    if (sortMode === 'price_asc') r.sort(function (a, b) { return priceOf(a) - priceOf(b); });
    else if (sortMode === 'price_desc') r.sort(function (a, b) { return priceOf(b) - priceOf(a); });
    else r.sort(function (a, b) { return (b.item.t || 0) - (a.item.t || 0); });
    return r;
  }
  function priceOf(row) { return row.variant ? row.variant.price : row.product.price; }

  function rowHTML(row, opts) {
    var p = row.product, v = row.variant;
    var img = imgUrl((p.featured_image || (p.images && p.images[0]) || ''), 240);
    var vt = row.item.vt || (v && v.title !== 'Default Title' ? v.title : '');
    var price = money(v ? v.price : p.price);
    var cta;
    var soldOut = v ? !v.available : !p.available;
    if (soldOut) {
      cta = '<button type="button" class="sierra-wl-item__cta" disabled>' + T.soldOut + '</button>';
    } else if (v && cartVariantIds.indexOf(v.id) > -1) {
      cta = '<a class="sierra-wl-item__cta" href="/cart">' + T.showInCart + '</a>';
    } else if (v) {
      cta = '<button type="button" class="sierra-wl-item__cta" data-wl-add-cart="' + v.id + '">' + T.addToCart + '</button>';
    } else {
      cta = '<a class="sierra-wl-item__cta" href="/products/' + p.handle + '">' + T.chooseSize + '</a>';
    }
    var removeBtn = opts.readonly ? '' :
      '<button type="button" class="sierra-wl-item__remove" data-wl-remove="' + p.handle + '" aria-label="' + T.remove + '">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';

    if (opts.grid) {
      return '<div class="sierra-wl-pcard">' +
        removeBtn +
        '<a href="/products/' + p.handle + '"><img class="sierra-wl-pcard__img" src="' + img.replace('width=240', 'width=600') + '" alt="" loading="lazy"></a>' +
        '<a class="sierra-wl-item__title" href="/products/' + p.handle + '">' + p.title + '</a>' +
        (vt ? '<span class="sierra-wl-item__variant">' + vt + '</span>' : '') +
        '<span class="sierra-wl-item__price">' + price + '</span>' +
        '<div class="sierra-wl-item__actions">' + cta + '</div>' +
        '</div>';
    }
    return '<div class="sierra-wl-item">' +
      '<a href="/products/' + p.handle + '"><img class="sierra-wl-item__img" src="' + img + '" alt="" loading="lazy"></a>' +
      '<div class="sierra-wl-item__body">' +
      '<a class="sierra-wl-item__title" href="/products/' + p.handle + '">' + p.title + '</a>' +
      (vt ? '<span class="sierra-wl-item__variant">' + vt + '</span>' : '') +
      '<span class="sierra-wl-item__price">' + price + '</span>' +
      '<div class="sierra-wl-item__actions">' + cta + '</div>' +
      '</div>' + removeBtn + '</div>';
  }

  function renderDrawer() {
    var wrap = document.getElementById('sierra-wl-items');
    var empty = document.getElementById('sierra-wl-empty');
    if (!wrap) return;
    var list = read();
    if (!list.length) {
      wrap.innerHTML = '';
      empty.hidden = false;
      return;
    }
    empty.hidden = true;
    resolveItems(list).then(function (rows) {
      wrap.innerHTML = sortRows(rows).map(function (r) { return rowHTML(r, {}); }).join('');
    });
  }

  /* ---------- share ---------- */
  function initShare(container, getList) {
    if (!container) return;
    container.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-wl-share]');
      if (!b) return;
      var mode = b.getAttribute('data-wl-share');
      var url = shareUrl(getList());
      trackShare(mode, getList().length);
      if (mode === 'copy') {
        copyText(url).then(function () { toast(T.linkCopied); });
      } else if (mode === 'instagram') {
        if (navigator.share) {
          navigator.share({ title: 'Мій список бажань — Sierra Space', url: url }).catch(function (err) {
            if (err && err.name !== 'AbortError') {
              copyText(url).then(function () { toast(T.igHint); });
            }
          });
        } else {
          copyText(url).then(function () { toast(T.igHint); });
        }
      } else if (mode === 'telegram') {
        window.open('https://t.me/share/url?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent('Мій список бажань — Sierra Space'), '_blank');
      } else if (mode === 'facebook') {
        window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url), '_blank');
      } else if (mode === 'download') {
        downloadList(getList());
      }
    });
  }

  function downloadList(list) {
    resolveItems(list || read()).then(function (rows) {
      var lines = ['Список бажань — Sierra Space', ''];
      sortRows(rows).forEach(function (r, idx) {
        var vt = r.item.vt || (r.variant && r.variant.title !== 'Default Title' ? r.variant.title : '');
        lines.push((idx + 1) + '. ' + r.product.title + (vt ? ' — ' + vt : '') + ' — ' + money(r.variant ? r.variant.price : r.product.price));
        lines.push('   ' + location.origin + '/products/' + r.product.handle);
      });
      lines.push('');
      lines.push(shareUrl(list));
      var blob = new Blob([lines.join('\n')], { type: 'text/plain;charset=utf-8' });
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'sierra-wishlist.txt';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(a.href);
    });
  }

  /* ---------- сторінка списку ---------- */
  function parseSharedParam() {
    var q = new URLSearchParams(location.search).get('items');
    if (!q) return null;
    return q.split(',').map(function (chunk) {
      var parts = chunk.split(':');
      return { h: parts[0], v: parts[1] ? parseInt(parts[1], 10) : null, vt: null, t: 0 };
    }).filter(function (i) { return /^[a-z0-9\-]+$/i.test(i.h); });
  }

  function initPage() {
    var grid = document.getElementById('sierra-wl-page-grid');
    if (!grid) return;
    var shared = parseSharedParam();
    var note = document.getElementById('sierra-wl-page-shared-note');
    var saveBtn = document.getElementById('sierra-wl-page-save');
    var isShared = !!(shared && shared.length);

    if (isShared && note) note.hidden = false;
    if (isShared && saveBtn) {
      saveBtn.hidden = false;
      saveBtn.addEventListener('click', function () {
        var mine = read();
        shared.forEach(function (i) {
          if (!mine.some(function (m) { return m.h === i.h; })) {
            mine.push({ h: i.h, v: i.v, vt: null, t: Date.now() });
          }
        });
        write(mine);
        toast(T.savedToMine);
        try {
          if (window.fbq) window.fbq('trackCustom', 'SaveSharedWishlist', { items_count: shared.length });
          if (window.gtag) window.gtag('event', 'save_shared_wishlist', { item_count: shared.length });
        } catch (err) {}
      });
    }

    function renderPage() {
      var list = isShared ? shared : read();
      if (!list.length) {
        grid.innerHTML = '<p style="grid-column:1/-1;text-align:center;color:#6b6b6b;padding:50px 0;">' + T.emptyList + '</p>';
        return;
      }
      refreshCart().then(function () {
        resolveItems(list).then(function (rows) {
          grid.innerHTML = sortRows(rows).map(function (r) { return rowHTML(r, { grid: true, readonly: isShared }); }).join('');
        });
      });
    }
    renderPage();
    if (!isShared) document.addEventListener('sierra:wl:change', renderPage);
    initShare(document.getElementById('sierra-wl-page-toolbar'), function () { return isShared ? shared : read(); });
  }

  /* ---------- глобальні обробники ---------- */
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-wl-remove]');
    if (rm) { removeItem(rm.getAttribute('data-wl-remove')); renderDrawer(); return; }
    var ac = e.target.closest('[data-wl-add-cart]');
    if (ac) { addToCart(parseInt(ac.getAttribute('data-wl-add-cart'), 10), ac); }
  });

  function init() {
    var tab = document.getElementById('sierra-wl-tab');
    if (tab) tab.addEventListener('click', openDrawer);
    var close = document.getElementById('sierra-wl-close');
    if (close) close.addEventListener('click', closeDrawer);
    var overlay = document.getElementById('sierra-wl-overlay');
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    var sort = document.getElementById('sierra-wl-sort');
    if (sort) sort.addEventListener('change', function () { sortMode = sort.value; renderDrawer(); });
    initShare(document.getElementById('sierra-wl-share'), function () { return read(); });
    initProductButton();
    initPage();
    syncUI();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* публічний API на всякий випадок */
  window.SierraWishlist = { read: read, toggle: toggleItem, open: openDrawer };
})();
